// TRON Globe
// I modified Ruairi Murphy's GridGlobe (https://www.openprocessing.org/sketch/121591).
// by whereismylightsaber
// 9th Oct, 2017
// https://openprocessing.org/sketch/559377

let WIREFRAME_SPHERE;
let DENSITY_WIREFRAME = 80; //density of wireframe
let globe = new Array(DENSITY_WIREFRAME);
let angleX = 0;
let angleY = 0;
let showGrid = true;
let showPoints = true;
let z;
let angleSpeed = 0.003;

function setup() {
    pixelDensity(2);

    var myCanvas = createCanvas(100, 100, WEBGL);
    myCanvas.parent("sphereButton");
    WIREFRAME_SPHERE = 200; //wireframe sphere radius
    for (let i = 0; i < DENSITY_WIREFRAME; i++) {
        globe[i] = new Globe(
            random(WIREFRAME_SPHERE * 2),
            random(WIREFRAME_SPHERE * 2),
            WIREFRAME_SPHERE,
            width / 2,
            height / 2
        );
    }
    z = -3500;
}

function draw() {
    // return;
    clear();

    // translate(-width / 2, -height / 2, 0);


    push();
    translate(width / 2 -50 , height / 2 - 50, z );
    rotateX(angleX);
    rotateY(angleY); //  fill(0);
    //  noStroke();
    //  sphere(190);
    for (let i = 0; i < globe.length; i++) {
        stroke(255);
        strokeWeight(2);
        if (showPoints) {
            globe[i].display();
        }
        if (showGrid) {
            for (let j = 0; j < globe.length; j++) {
                if (
                    dist(
                        globe[i].pX,
                        globe[i].pY,
                        globe[i].pZ,
                        globe[j].pX,
                        globe[j].pY,
                        globe[j].pZ
                    ) < 120
                ) {
                    stroke('#ffffff');
                    line(
                        globe[i].pX,
                        globe[i].pY,
                        globe[i].pZ,
                        globe[j].pX,
                        globe[j].pY,
                        globe[j].pZ
                    );
                }
            }
        }
    }
    pop(); // angle = map(mouseX,0,width,0,TWO_PI);
    angleY += angleSpeed;
}

class Globe {
    horizontal;
    vertical;
    pX;
    pY;
    pZ;
    thisRadius;
    constructor(_horizontal, _vertical, _radius, _midX, _midY) {
        this.horizontal = (_horizontal * PI) / 180;
        this.vertical = (_vertical * PI) / 180;
        this.thisRadius = _radius + random(-3, 5);
    }
    display() {
        this.pX = -this.thisRadius * cos(this.horizontal) * cos(this.vertical);
        this.pY = +this.thisRadius * sin(this.horizontal);
        this.pZ = +this.thisRadius * cos(this.horizontal) * sin(this.vertical);
        console.log
        push();
        translate(this.pX, this.pY, this.pZ);
        fill('#ffffff');
        noStroke();
        // ellipse(0, 0, 25);
        sphere(8);
        pop();
    }
}